import React from "react";
import "./UniformTable.css";

/**
 * UniformTable – grid‑style table with a sticky header and a scrollable body.
 *
 * Props
 * -----
 * columns: Array<{ accessor: string, header: string, width?: string }>
 * data   : Array<Record<string, any>>
 *
 * The surrounding CSS (`.table-responsive`) provides:
 *   • `max-height: 650px` – table stops growing after ~650 px.
 *   • `overflow-y: auto` – a vertical scrollbar appears only for the rows.
 *
 * By wrapping the rows in a `<div className="table-body">` the header
 * (`.table-header`) stays fixed while only the rows scroll.
 */
export default function UniformTable({ columns, data }) {
  return (
    <div className="uniform-table">
      {/* -------------------------------------------------
          Scrollable container – height & overflow are handled by CSS
          ------------------------------------------------- */}
      <div className="table-responsive">
        {/* ------------------- Sticky Header ------------------- */}
        <div className="table-header">
          {columns.map(col => (
            <div key={col.accessor} className="cell">
              {col.header}
            </div>
          ))}
        </div>

        {/* ------------------ Scrollable Rows ----------------- */}
        <div className="table-body">
          {data.map((row, i) => (
            <div key={row.id || i} className="table-row">
              {columns.map(col => (
                <div key={col.accessor} className="cell">
                  {row[col.accessor] ?? "-"}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
